
export const environment = {
  production: true,
  showPoweredBy: true,
  apiUrlBase: 'https://cicerone.cms-iurban.com',
  // Diccionarios de UI que sirve el CMS (fallback-translate.loader)
  langsBaseUrl: 'https://cms-iurban.com/langs/',
  apiAssistantUrlBase: 'https://v3.gpt.cms-iurban.com',
  urlWebSocket: 'wss://v3.gpt.cms-iurban.com/ws/assistant',
  urlWebSocketTools: 'wss://v3.gpt.cms-iurban.com/ws/assistant/tool-feedback',
  urlChatHistory: 'https://v3.gpt.cms-iurban.com/api/chat/history',
  urlTextToSpeech: 'https://v3.gpt.cms-iurban.com/tts/stream',
  googleMapsApiKey: 'AIzaSyCosmIo9py_6Dfd_mr1CWSJxQtDzl1LWjA',
  googlePlacesApiKey: 'AIzaSyCs0X4MMRnYLRqwpflGDnr64FQ7QXviFko',
  pdfServiceUrl: 'https://node.ciceroneweb.com/details-pdf',
  serviceWorker: true,
  // HRS-3045: Sentry solo se descarga (chunk propio) si hay DSN. null = sin Sentry.
  // DSN histórico del proyecto (desactivado desde que se puso a null en main.ts):
  // 'https://ac6f0b26fe5ef3f66265dc6f5577273e@o4510035615416320.ingest.de.sentry.io/4510061988282448'
  sentryDsn: null as string | null,

  pdfExportCCMM: {
    enabled: false,
    frontendUrl: 'https://miruta.visitmadrid.es/front',
    backendUrl: 'https://miruta.visitmadrid.es/cms/api/details-pdf',
  },
  // Offline base-map tiles for downloaded hiking routes. urlTemplate must
  // point to a source whose terms PERMIT offline caching (self-hosted
  // OSM-derived raster {z}/{x}/{y}.png). Never OSM/Google tile servers.
  // Empty urlTemplate = feature disabled (safe no-op, blank base map).
  offlineTiles: {
    urlTemplate: 'https://cms-iurban.com/osm/{z}/{x}/{y}.png',
    maxZoom: 16,
    maxTilesPerRoute: 3000,
  }
};

//from 10 tp 15 juliy, i travel in couple, i want to see culture, gastronomy, nature, shopping, events, local life, visit center and 30km
